<template>
  <div>

    <div class="col-xs-12">
      {{channelDisplayFlag}}
      <div class="col-xs-4">
        <label class="col-xs-12 align-center" for="example-multiple-select">{{ textSectionActualMeasurement[actualLanguage] }}</label>
        <pie-chart :chartData="crunchedMaxCurrent"></pie-chart>
      </div>
    </div>

  </div>


</template>

<script>

import _ from 'underscore'
import {mapState, mapActions,mapGetters} from 'vuex'
import PieChart from '@/components/PieChart'

export default {
  props: ['channelDisplayFlag'],
  components: {
    PieChart
  },
  data() {
    return {    
      actualLanguage : "FR",
      showListOfChannel : false,
      flagDisplayFilter : 0,
      attributesFilters : [],
      attributesFiltersChoice : [],
      channelCount : 0,
      channelsParamaters : [],
      channelsMmMaximums : {'5Min':0,'MA_001H':0,'MA_004H':0,'MA_006H':0,'MA_012H':0,'MA_024H':0,'MA_072H':0,'MA_168H':0,'MA_336H':0,'MA_720H':0},

      textSectionActualMeasurement:{FR: "Mesures actuelles", EN: 'Actual measurements'},

      crunchedMaxCurrent: {
        labels: ['Data 1','Datadsfsdf 2','Datsdfdsfsdfsda 3','Data 1','Dasdfsdfdsfta 2','Data 3','Data 1','Data 2','Data 3'],
        datasets: [{
          label: 'Mesure',
          backgroundColor: [
                    'rgba(171, 227, 125, 1)',
                    'rgba(250, 219, 125, 1)',
                    'rgba(117, 176, 235, 1)',
                    'rgba(117, 200, 235, 1)',
                    'rgba(117, 250, 235, 1)',
                    'rgba(150, 250, 235, 1)',
                    'rgba(190, 250, 235, 1)',
                    'rgba(210, 250, 235, 1)',
                    'rgba(230, 250, 235, 1)',
                    'rgba(250, 250, 235, 1)',
                    'rgba(117, 250, 235, 1)',
                    'rgba(117, 250, 235, 1)',
                ],
          data: [10,20,30,40,50,60,70,80,90,100]
        }]
      },

    
    }
  },


  computed: {
    ...mapState('sessionStore', ['profileData','displayAdminFlag','groupArborescence','actualBundle']),
  },


  methods: {

    resetDisplayFlag(){
      this.channelDisplayFlag = []
      var previousDisplayFilter = this.flagDisplayFilter
    },

  },

  mounted() {

    if(localStorage.language){this.actualLanguage =  localStorage.language}
      else{this.actualLanguage = 'FR'}
  },

  beforeMount(){
    
  }


}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// PieChartPowerAverage.vue?03671e90